import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import Tag from "components/base/Tag";
import { FETCH_OBJECT_TAGS } from "graphql/tags";
import { useContext } from "react";
import { ProductContext } from "./ProductForm";

const ProductTagsView = () => {
  const { id } = useContext(ProductContext);

  const { loading, error, data } = useQuery(FETCH_OBJECT_TAGS, {
    variables: {
      contentTypeAppLabel: "product",
      contentTypeName: "product",
      objectId: id,
    },
  });

  console.log("data", data);

  return (
    <div className="card">
      <div className="flex justify-between items-center">
        <h5>Tags</h5>
        <Button>Edit</Button>
      </div>
      <div className="mt-2">
        {loading ? (
          <InlineSpinner />
        ) : error ? (
          <Errors error={error} />
        ) : (
          <div className="flex flex-wrap gap-2">
            {data.taggingObjectTags.map((i) => (
              <Tag key={i.id} value={i.value} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductTagsView;
